import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterDrivenWheelsIdsSearchValueObject extends ValueObject {
  #drivenWheelsIds

  constructor({drivenWheelsIds}) {
    super()
    this.#drivenWheelsIds = drivenWheelsIds
  }

  static create({drivenWheelsIds}) {
    return new FilterDrivenWheelsIdsSearchValueObject({
      drivenWheelsIds: FilterIdsArraySearchValueObject.create(drivenWheelsIds)
    })
  }

  static createWithDefaultValue({config, drivenWheelsIds}) {
    const {DEFAULT_DRIVEN_WHEELS_SEARCH} = config.get('searchFilters')

    return new FilterDrivenWheelsIdsSearchValueObject({
      drivenWheelsIds: FilterIdsArraySearchValueObject.createForNumbers({
        value: drivenWheelsIds ?? DEFAULT_DRIVEN_WHEELS_SEARCH
      })
    })
  }

  static createQueryParams({config, drivenWheelsIds}) {
    const {DEFAULT_DRIVEN_WHEELS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterDrivenWheelsIdsSearchValueObject({
      drivenWheelsIds: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.DRIVEN_WHEELS],
        value: drivenWheelsIds ?? DEFAULT_DRIVEN_WHEELS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#drivenWheelsIds.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#drivenWheelsIds.queryParam})
    }
  }

  get value() {
    return this.#drivenWheelsIds.value
  }

  toJSON() {
    return {
      drivenWheelsIds: this.#drivenWheelsIds.toJSON()
    }
  }
}
